

<script>
    import { onMount } from 'svelte'
	export let name

	let profiles = []

    onMount(() => {
        setUpProfiles()
    });

	const setUpProfiles = () => {
	    profiles = [] // reset them
	    for(let i=0;i<2;i++) {
	        let quote = quotes[Math.floor(Math.random() * quotes.length)];
	        let pic = pics[Math.floor(Math.random() * pics.length)];
	        profiles.push({quote, pic})
        }

	    let i=1
	    profiles.forEach((profile) => {
	        document.getElementById('pic' + i).src=profile.pic + '&cb=' + Math.random()
            document.getElementById('quote' + i).innerText=profile.quote
            i++
        })
    }

    const rate = (up) => {
	    setUpProfiles()
    }

</script>

<style>
    body {
        font-family: "Assistant";
    }
	h1 {
        font-family: "Alegreya Sans SC";
	}
    .profile {
        text-align: center;
    }
    blockquote {
        font-size:xx-large;
    }
    .rate-area {
        text-align: center;
    }
</style>


<h1>Odds Are</h1>
<div class="container">
    <div class="row">
        <div class="col-12 col-md-6 profile">
            <img class="img-fluid" src="" id="pic1">
            <blockquote id="quote1">Loading...</blockquote>
        </div>
        <div class="col-12 col-md-6 profile">
            <img class="img-fluid" src="" id="pic2">
            <blockquote id="quote2">Loading...</blockquote>
        </div>
    </div>
    <div class="rate-area">
        <button class="thumb btn btn-primary" on:click="{e => rate(true)}">Up</button>
        <button class="thumb btn btn-secondary" on:click="{e => rate(false)}">Do</button>

    </div>

</div>